var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{ref:"watermark",staticClass:"watermark-container"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }